export default __webpack_public_path__ + "static/logo-8-049471f56e8fb4df178e0df973fa9bb4.webp";